import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './MigrationPrompt.css';

const MigrationPrompt = ({ childProfile, onComplete }) => {
  const { anonymousActivity, migrateSessionData, resetAnonymousActivity } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [migrationResults, setMigrationResults] = useState(null);

  // Don't show if there's no anonymous content
  if (!anonymousActivity.hasContent) {
    if (onComplete) {
      onComplete(null);
    }
    return null;
  }

  const handleMigration = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const results = await migrateSessionData(childProfile.id);
      setMigrationResults(results);
      
      if (onComplete) {
        onComplete(results);
      }
    } catch (err) {
      setError('Failed to migrate your content. Please try again.');
      console.error('Migration failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    // Just reset the anonymous activity without migrating
    resetAnonymousActivity();
    
    if (onComplete) {
      onComplete(null);
    }
  };

  // Show migration results if available
  if (migrationResults) {
    return (
      <div className="migration-prompt migration-success">
        <h2>Success!</h2>
        <p>We've saved your stories and characters to your account.</p>
        <ul>
          <li>{migrationResults.stories_migrated} {migrationResults.stories_migrated === 1 ? 'story' : 'stories'} saved</li>
          <li>{migrationResults.characters_migrated} {migrationResults.characters_migrated === 1 ? 'character' : 'characters'} saved</li>
        </ul>
        <button onClick={() => onComplete(migrationResults)}>
          Continue
        </button>
      </div>
    );
  }

  return (
    <div className="migration-prompt">
      <h2>We found your stories!</h2>
      <p>
        Would you like to save your content to {childProfile.name}'s profile?
      </p>
      <ul>
        {anonymousActivity.storiesCreated > 0 && (
          <li>{anonymousActivity.storiesCreated} {anonymousActivity.storiesCreated === 1 ? 'story' : 'stories'}</li>
        )}
        {anonymousActivity.charactersCreated > 0 && (
          <li>{anonymousActivity.charactersCreated} {anonymousActivity.charactersCreated === 1 ? 'character' : 'characters'}</li>
        )}
      </ul>
      
      {error && <p className="error-message">{error}</p>}
      
      <div className="button-row">
        <button 
          className="confirm-button" 
          onClick={handleMigration}
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Yes, Save My Content'}
        </button>
        <button 
          className="skip-button" 
          onClick={handleSkip}
          disabled={loading}
        >
          No, Start Fresh
        </button>
      </div>
    </div>
  );
};

export default MigrationPrompt;